

import { Component, Vue } from 'vue-property-decorator';
import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/ListTab.vue';
import TabsNav from '@/components/tabs/TabsNavIcons.vue';

import DirectoriesModule from '@/store/directories';
import SubscriptionsModule from '@/store/subscriptions';

@Component({
    components: {
        Layout,
        ListBlock,
        TabsNav,
    }
})
export default class SubscriptionsPage extends Vue {
    repository = SubscriptionsModule;

    get tabsNav() {
        return DirectoriesModule.tabsNav;
    }


    get currentTab() {
        return DirectoriesModule.allTabs.subscriptions.id;
    }
    
    get tabsNavList() {
        return SubscriptionsModule.tabsNav;
    }

    get currentTabList() {
        return SubscriptionsModule.allTabs.subscriptions.id;
    }

    get filterSettings() {
        return this.repository.filter.filterSettings;
    }

    async updateList() {
        await this.repository.filter.updateFilter();
        await this.repository.updatePage('1');
    }

    async resetFilters() {
        await this.repository.clearSort();
        await this.repository.filter.resetFilter();
        await this.repository.updatePage('1');
    }
}
